import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICompanyResponse } from '../../../core/models/company.model';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CompanySearchService {

  constructor(private http: HttpClient) { }


  companySearch(
    name?: string,
    isin?: string,
    url?: string | null,
    companytype?: string | null
  ) {
    let body = {
      "num_matches": "100",
      "name": name ?? '',
      "isin": isin ?? '',
      "url": url ?? '',
      "companytype": companytype ?? null
	    }
    return this.http.post<ICompanyResponse>("/backend/company/search", body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("current_user_token")}`,
      },
      responseType: "json",
    });
  }


  downloadPdfReportV2(
    companyid: number | null | undefined,
  ) {
    var params = new HttpParams();
    params = params.append("companyid", companyid!);

    return this.http.get(
      "/backend/report/pdf/v2",
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("current_user_token"),
        },
        params: params,
        responseType: "blob",
        observe: "response",
      }
    );
  }

  downloadPdfReportV1(
    entityid: string | null | undefined,
  ) {
    var params = new HttpParams();
    params = params.append("entityid", entityid!);

    return this.http.get(
      "/backend/report/pdf/v1",
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("current_user_token"),
        },
        params: params,
        responseType: "blob",
        observe: "response",
      }
    );
  }


}
